var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { add, areIntervalsOverlapping, sub } from 'date-fns';
import { DayOfWeek } from '@square/dashboard-items-data/models/connect/availability-period/data';
import { tracked } from '@glimmer/tracking';
const DAYS_OF_WEEK_STARTING_MON = [DayOfWeek.MON, DayOfWeek.TUE, DayOfWeek.WED, DayOfWeek.THU, DayOfWeek.FRI, DayOfWeek.SAT, DayOfWeek.SUN];
const DAYS_OF_WEEK_STARTING_SUN = [DayOfWeek.SUN, DayOfWeek.MON, DayOfWeek.TUE, DayOfWeek.WED, DayOfWeek.THU, DayOfWeek.FRI, DayOfWeek.SAT];

// TODO: use Intl.Locale.prototype.getWeekInfo() instead of hardcoded config when it gets full browser support
const FIRST_DAY_OF_WEEK_FOR_LOCALE = {
  'en-au': DayOfWeek.MON,
  'en-ca': DayOfWeek.SUN,
  'fr-ca': DayOfWeek.SUN,
  fr: DayOfWeek.MON,
  'fr-fr': DayOfWeek.MON,
  'en-ie': DayOfWeek.MON,
  ja: DayOfWeek.SUN,
  'ca-es': DayOfWeek.MON,
  'es-es': DayOfWeek.MON,
  'en-gb': DayOfWeek.MON,
  es: DayOfWeek.SUN,
  'es-us': DayOfWeek.SUN,
  'en-us': DayOfWeek.SUN
};

/**
 * Returns a locale-aware list of the days of the week. Defaults to Monday first if locale not found.
 * e.g. en-US --> ['SUN','MON','TUE','WED','THU','FRI','SAT']
 * es-ES --> ['MON','TUE','WED','THU','FRI','SAT','SUN']
 * @param locale the locale to get the days of week for
 * @returns DayOfWeek[]
 */
export function getLocalizedDaysOfWeek(locale) {
  const lowercaseLocale = locale.toLowerCase();
  const firstDayOfWeek = FIRST_DAY_OF_WEEK_FOR_LOCALE[lowercaseLocale] ?? DayOfWeek.MON;
  return firstDayOfWeek === DayOfWeek.MON ? DAYS_OF_WEEK_STARTING_MON : DAYS_OF_WEEK_STARTING_SUN;
}
export let WrappedAvailabilityPeriod = (_class = class WrappedAvailabilityPeriod {
  constructor({
    availabilityPeriodModel,
    daysOfWeek
  }) {
    _defineProperty(this, "availabilityPeriodModel", void 0);
    _defineProperty(this, "daysOfWeek", void 0);
    _initializerDefineProperty(this, "isStartValid", _descriptor, this);
    _initializerDefineProperty(this, "isEndValid", _descriptor2, this);
    _defineProperty(this, "createDateFnsInterval", () => {
      return {
        start: this.startDate,
        end: this.endDate
      };
    });
    _defineProperty(this, "clearErrors", () => {
      this.isStartValid = true;
      this.isEndValid = true;
    });
    this.availabilityPeriodModel = availabilityPeriodModel;
    this.daysOfWeek = daysOfWeek;
  }
  get dayOfWeek() {
    return this.availabilityPeriodModel.dayOfWeek;
  }
  get isFirstDayOfWeek() {
    return this.dayOfWeek === this.daysOfWeek[0];
  }
  get isLastDayOfWeek() {
    return this.dayOfWeek === this.daysOfWeek[this.daysOfWeek.length - 1];
  }
  get endLocalTime() {
    return this.availabilityPeriodModel.endLocalTime;
  }
  get startLocalTime() {
    return this.availabilityPeriodModel.startLocalTime;
  }
  get isValid() {
    return this.isStartValid && this.isEndValid;
  }
  get dayOnCalendar() {
    return getCalendarDayFromWeekDay(this.dayOfWeek, this.daysOfWeek);
  }
  get startDate() {
    return createDateFromDayAndTime(this.dayOnCalendar, this.startLocalTime);
  }
  get endDate() {
    return createDateFromDayAndTime(this.dayOnCalendar, this.endLocalTime);
  }
  get isEndTimeNextDay() {
    const startDate = createDateFromTime(this.startLocalTime);
    const endDate = createDateFromTime(this.endLocalTime);
    return startDate > endDate;
  }
  get isEndTimeNextWeek() {
    return this.isLastDayOfWeek && this.isEndTimeNextDay;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isStartValid", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isEndValid", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _class);

/**
 * Creates a padded string number that represents a day. For example, "08" represents the 8th of January, 1970.
 * MON corresponds to 1970-01-05 hence the returned number is "05"
 * TUE corresponds to 1970-01-06 hence the returned number is "06"
 * WED corresponds to 1970-01-07 hence the returned number is "07"
 * THU corresponds to 1970-01-08 hence the returned number is "08"
 * FRI corresponds to 1970-01-09 hence the returned number is "09" etc.
 * @param dayOfWeek dayOfWeek from DaysOfWeek enum. Can be "MON", "TUE", "WED" etc.
 * @param daysOfWeek locale-aware array of the days of the week
 * @returns string which is always greater than 04
 */
function getCalendarDayFromWeekDay(dayOfWeek, daysOfWeek) {
  const indexOfDay = daysOfWeek.indexOf(dayOfWeek);

  // If Sunday is first day of week, dateOffset equals 4 since 1970-01-04 is Sunday
  // If Monday is first day of week, dateOffset equals 5 since 1970-01-05 is Monday
  const dateOffset = DAYS_OF_WEEK_STARTING_SUN.indexOf(daysOfWeek[0]) + 4;
  return String(indexOfDay + dateOffset).padStart(2, '0');
}

/**
 * Converts a time string to date to perform easier date calculations.
 * @param time set in partial-time RFC 3339. For example, "8:30:00" specifies 8:30 in the morning.
 * @returns Date
 */
export function createDateFromTime(time) {
  return new Date(`1970-01-01T${time}+00:00`);
}

/**
 * Converts a day string and a time string to date to perform easier date calculations.
 * @param numOfDay a padded string number that represent a day. For example, "08" represents the 8th of the month.
 * @param time set in partial-time RFC 3339. For example, "8:30:00" specifies 8:30 in the morning.
 * @returns Date
 */
function createDateFromDayAndTime(numOfDay, time) {
  return new Date(`1970-01-${numOfDay}T${time}+00:00`);
}

/**
 * Checks if two availability periods are overlapping. Internally, it calls date-fns's
 * areIntervalsOverlapping.
 * @param availabilityPeriod1: First availability period of the comparison
 * @param availabilityPeriod2: Second availability period of the comparison
 * @returns boolean
 */
export function areAvailabilityPeriodsOverlapping(availabilityPeriod1, availabilityPeriod2) {
  const interval1 = availabilityPeriod1.createDateFnsInterval();
  const interval2 = availabilityPeriod2.createDateFnsInterval();

  // Only the last availability period can have it's end time as next week.
  // In the wrap around validation performed inside the availability-period-manager's validateWrappedAvailabilityPeriods function,
  // the last availability period corresponds to availabilityPeriod1
  // To make the date comparison, we need to shift start and end times by 1 week and add 1 day to end time to account for next day.
  if (availabilityPeriod1.isEndTimeNextWeek) {
    interval1.start = sub(interval1.start, {
      weeks: 1
    });
    interval1.end = sub(interval1.end, {
      weeks: 1
    });
  }
  if (availabilityPeriod1.isEndTimeNextDay) {
    interval1.end = add(interval1.end, {
      days: 1
    });
  }
  if (availabilityPeriod2.isEndTimeNextDay) {
    interval2.end = add(interval2.end, {
      days: 1
    });
  }
  return areIntervalsOverlapping(interval1, interval2, {
    inclusive: true
  });
}
export function areAvailabilityPeriodsIdentical(availabilityPeriod1, availabilityPeriod2) {
  return availabilityPeriod1.dayOfWeek === availabilityPeriod2.dayOfWeek && availabilityPeriod1.startLocalTime === availabilityPeriod2.startLocalTime && availabilityPeriod1.endLocalTime === availabilityPeriod2.endLocalTime;
}

/**
 * A sorting comparator for availability periods that first sorts them on day, then on startTime and finally on endTime
 * @param availabilityPeriodA
 * @param availabilityPeriodB
 * @param daysOfWeek locale-aware array of the days of the week
 * @returns number
 */
export function availabilityPeriodComparator(availabilityPeriodA, availabilityPeriodB, daysOfWeek) {
  const dayPriority = compareDay(availabilityPeriodA, availabilityPeriodB, daysOfWeek);
  const startTimePriority = compareTime(availabilityPeriodA.startLocalTime, availabilityPeriodB.startLocalTime);
  const endTimePriority = compareTime(availabilityPeriodA.endLocalTime, availabilityPeriodB.endLocalTime);
  return dayPriority || startTimePriority || endTimePriority;
}
function compareDay(availabilityPeriodA, availabilityPeriodB, daysOfWeek) {
  return daysOfWeek.indexOf(availabilityPeriodA.dayOfWeek) - daysOfWeek.indexOf(availabilityPeriodB.dayOfWeek);
}
function compareTime(timeA, timeB) {
  const dateA = createDateFromTime(timeA);
  const dateB = createDateFromTime(timeB);
  return dateA.getTime() - dateB.getTime();
}

/**
 * Strips of hours from a Date as expected by AvailabilityPeriod.localStartTime and AvailabilityPeriod.localEndTime
 * For example an input of new Date("1970-01-01T09:00") would return 09:00
 * @param date
 * @returns
 */
export function getTimeFromDate(date) {
  // Javascript creates Dates with timezones. If a user was in GMT-05:00:00, they'd have
  // Thu Jan 01 1970 18:15:00 GMT-0500 for 00:15:00. To convert the date to 00:15:00, we need to add
  // the timezone offset back and then get its modulo 24
  const hoursNum = (date.getHours() + date.getTimezoneOffset() / 60) % 24;
  const hours = String(hoursNum).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}:00`;
}

/**
 * Converts a timeString from 24 hour format required by the backend to 12 or 24 hour localized format
 * For example 18:00:00 would be converted to "6:00 PM" in en-US and "18 h 00" in fr-CA
 * @param timeString
 * @returns string
 */
export function convertTimeStringToLocalizedFormat(languageCode, timeString) {
  return createDateFromTime(timeString).toLocaleTimeString(languageCode, {
    timeZone: 'UTC',
    hour: 'numeric',
    minute: 'numeric'
  });
}